/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelptitle2Inputs */

const en_crosspostinghelptitle2 = /** @type {(inputs: Crosspostinghelptitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting accounts - help`)
};

const de_crosspostinghelptitle2 = /** @type {(inputs: Crosspostinghelptitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten verbinden – Hilfe`)
};

/**
* | output |
* | --- |
* | "Connecting accounts - help" |
*
* @param {Crosspostinghelptitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelptitle2 = /** @type {((inputs?: Crosspostinghelptitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelptitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelptitle2(inputs)
	return de_crosspostinghelptitle2(inputs)
});
export { crosspostinghelptitle2 as "crosspostingHelpTitle" }